var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单管理")]),
              _c("el-breadcrumb-item", [_vm._v("Dcops工单")]),
              _c("el-breadcrumb-item", [_vm._v("TPC异常处理")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.create_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "create_time", $$v)
                                },
                                expression: "searchForm.create_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否超时" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "全部" },
                                model: {
                                  value: _vm.searchForm.is_timeout,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "is_timeout", $$v)
                                  },
                                  expression: "searchForm.is_timeout"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "是", value: "是" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "否", value: "否" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单号" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "请输入工单号"
                              },
                              model: {
                                value: _vm.searchForm.ticket_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticket_id", $$v)
                                },
                                expression: "searchForm.ticket_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "如 处理中"
                              },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域-园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.campus,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campus", $$v)
                                  },
                                  expression: "searchForm.campus"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "处理人" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "支持模糊搜索"
                              },
                              model: {
                                value: _vm.searchForm.handle_user,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "handle_user", $$v)
                                },
                                expression: "searchForm.handle_user"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "SN" } },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", placeholder: "明细 SN" },
                              model: {
                                value: _vm.searchForm.sn,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "sn", $$v)
                                },
                                expression: "searchForm.sn"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "固资" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "明细固资号"
                              },
                              model: {
                                value: _vm.searchForm.asset_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "asset_id", $$v)
                                },
                                expression: "searchForm.asset_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("TPC异常处理列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      plain: "",
                      loading: _vm.syncLoading,
                      disabled: _vm.syncLoading
                    },
                    on: { click: _vm.openSyncDialog }
                  },
                  [_vm._v("\n          更新TPC列表\n        ")]
                ),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                staticClass: "tpc-table",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.showData,
                  border: "",
                  stripe: "",
                  "row-key": "ticket_id"
                },
                on: {
                  "selection-change": _vm.handleSelectionChange,
                  "expand-change": _vm.handleExpand
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      "min-width": column.minWidth,
                      width: column.width,
                      align: column.align,
                      "show-overflow-tooltip": column.tooltip !== false
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "ticket_id"
                                ? [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.ticket_id || "-"))
                                    ])
                                  ]
                                : column.prop === "status"
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.statusTagType(
                                            scope.row.status
                                          ),
                                          size: "small"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.status || "-"))]
                                    )
                                  ]
                                : column.prop === "is_timeout"
                                ? [
                                    scope.row.is_timeout === "是"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "small",
                                              effect: "dark"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                是\n              "
                                            )
                                          ]
                                        )
                                      : scope.row.is_timeout === "否"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "small",
                                              effect: "plain"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                否\n              "
                                            )
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatCell(
                                                scope.row,
                                                column.prop
                                              )
                                            )
                                          )
                                        ])
                                  ]
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCell(scope.row, column.prop)
                                      )
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "expand",
                    label: "工单详情",
                    width: "88",
                    align: "center",
                    fixed: "right",
                    "class-name": "tpc-detail-expand-col"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value:
                                    _vm.detailLoadingMap[props.row.ticket_id],
                                  expression:
                                    "detailLoadingMap[props.row.ticket_id]"
                                }
                              ],
                              staticClass: "detail-expand-wrap"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "detail-summary-bar" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "primary",
                                        effect: "plain",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  共 " +
                                          _vm._s(
                                            (
                                              _vm.detailMap[
                                                props.row.ticket_id
                                              ] || []
                                            ).length
                                          ) +
                                          " 台设备\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "detail-summary-id" },
                                    [
                                      _vm._v(
                                        "工单号：" + _vm._s(props.row.ticket_id)
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              !(_vm.detailMap[props.row.ticket_id] || [])
                                .length &&
                              !_vm.detailLoadingMap[props.row.ticket_id]
                                ? _c("el-empty", {
                                    attrs: {
                                      description: "暂无设备明细",
                                      "image-size": 72
                                    }
                                  })
                                : _vm._e(),
                              _vm._l(
                                _vm.detailMap[props.row.ticket_id] || [],
                                function(device, dIdx) {
                                  return _c(
                                    "div",
                                    {
                                      key: device.id || dIdx,
                                      staticClass: "device-card"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "device-card-header" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "device-badge" },
                                            [_vm._v("设备 " + _vm._s(dIdx + 1))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "device-asset" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.displayDetail(
                                                    device,
                                                    "asset_id"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          device.is_ai_model === "是"
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "warning",
                                                    effect: "plain"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    AI服务器\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          device.is_timeout === "是"
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "danger",
                                                    effect: "dark"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    超时\n                  "
                                                  )
                                                ]
                                              )
                                            : device.is_timeout === "否"
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "success",
                                                    effect: "plain"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    未超时\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "device-card-body",
                                          attrs: { gutter: 16 }
                                        },
                                        [
                                          _c("el-col", { attrs: { span: 8 } }, [
                                            _c(
                                              "div",
                                              { staticClass: "info-panel" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "panel-title"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "el-icon-cpu"
                                                    }),
                                                    _vm._v(" 设备信息")
                                                  ]
                                                ),
                                                _c(
                                                  "el-descriptions",
                                                  {
                                                    attrs: {
                                                      column: 1,
                                                      size: "small",
                                                      border: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: { label: "SN" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "sn"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "是否AI服务器"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "is_ai_model"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: { label: "机型" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "model"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "一级机房"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "idcp_name"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "机房单元"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "idc_name"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "机架/机位"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.displayDetail(
                                                                device,
                                                                "rack_name"
                                                              )
                                                            ) +
                                                            " / " +
                                                            _vm._s(
                                                              _vm.displayDetail(
                                                                device,
                                                                "pos_name"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "操作类型"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              type: "info"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayDetail(
                                                                  device,
                                                                  "cztype",
                                                                  "cztype"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: { label: "场景" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "scene"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]),
                                          _c("el-col", { attrs: { span: 8 } }, [
                                            _c(
                                              "div",
                                              { staticClass: "info-panel" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "panel-title"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning-outline"
                                                    }),
                                                    _vm._v(" 异常信息")
                                                  ]
                                                ),
                                                _c(
                                                  "el-descriptions",
                                                  {
                                                    attrs: {
                                                      column: 1,
                                                      size: "small",
                                                      border: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "异常类型"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "event_type"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "异常描述"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-block"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayDetail(
                                                                  device,
                                                                  "exception"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "结单描述"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-block"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayDetail(
                                                                  device,
                                                                  "handle_detail"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "结单异常类型"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "end_exception_item"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]),
                                          _c("el-col", { attrs: { span: 8 } }, [
                                            _c(
                                              "div",
                                              { staticClass: "info-panel" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "panel-title"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-time"
                                                    }),
                                                    _vm._v(" 超时与操作")
                                                  ]
                                                ),
                                                _c(
                                                  "el-descriptions",
                                                  {
                                                    attrs: {
                                                      column: 1,
                                                      size: "small",
                                                      border: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "是否超时"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "is_timeout"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "一级原因"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "first_timeout_reason"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "二级原因"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "second_timeout_reason"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "超时描述"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-block"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayDetail(
                                                                  device,
                                                                  "timeout_desc"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "申请免责"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "apply_impunity"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "到达现场"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "arrive_site_time",
                                                              "date"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-descriptions-item",
                                                      {
                                                        attrs: {
                                                          label: "开始操作"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayDetail(
                                                              device,
                                                              "start_operate_time",
                                                              "date"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                device.arrive_site_time ||
                                                device.start_operate_time
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mini-timeline"
                                                      },
                                                      [
                                                        device.arrive_site_time
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "timeline-node"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "dot on"
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "label"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "到达现场"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatTime(
                                                                          device.arrive_site_time
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        device.start_operate_time
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "timeline-node"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "dot on"
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "label"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "开始操作"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatTime(
                                                                          device.start_operate_time
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "attach-panel" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "panel-title" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline"
                                              }),
                                              _vm._v(" 附件与举证")
                                            ]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            _vm._l(
                                              _vm.urlFieldBlocks(device),
                                              function(block) {
                                                return _c(
                                                  "el-col",
                                                  {
                                                    key: block.prop,
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "url-block"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "url-block-label"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                block.label
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        !block.urls.length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "url-empty"
                                                              },
                                                              [_vm._v("---")]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "url-block-content"
                                                              },
                                                              [
                                                                _vm._l(
                                                                  block.urls,
                                                                  function(
                                                                    url,
                                                                    uIdx
                                                                  ) {
                                                                    return [
                                                                      _vm.isValidUrl(
                                                                        url
                                                                      ) &&
                                                                      _vm.isImageUrl(
                                                                        url
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                block.prop +
                                                                                "-img-" +
                                                                                uIdx,
                                                                              staticClass:
                                                                                "url-image-item"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "el-image",
                                                                                {
                                                                                  staticClass:
                                                                                    "url-preview-img",
                                                                                  attrs: {
                                                                                    src: url,
                                                                                    fit:
                                                                                      "cover",
                                                                                    "preview-src-list":
                                                                                      block.imageUrls
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm.isValidUrl(
                                                                            url
                                                                          )
                                                                        ? _c(
                                                                            "a",
                                                                            {
                                                                              key:
                                                                                block.prop +
                                                                                "-dl-" +
                                                                                uIdx,
                                                                              staticClass:
                                                                                "url-download-link",
                                                                              attrs: {
                                                                                href: url,
                                                                                target:
                                                                                  "_blank",
                                                                                rel:
                                                                                  "noopener noreferrer"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "el-icon-download"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " 下载链接\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              key:
                                                                                block.prop +
                                                                                "-na-" +
                                                                                uIdx,
                                                                              staticClass:
                                                                                "url-not-link"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "---"
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  }
                                                                )
                                                              ],
                                                              2
                                                            )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "选择月份范围",
                  visible: _vm.monthSelectDialogVisible,
                  width: "700px",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.monthSelectDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.monthSelectForm,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "开始月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择开始月份",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.startMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "startMonth", $$v)
                            },
                            expression: "monthSelectForm.startMonth"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择结束月份",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.endMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "endMonth", $$v)
                            },
                            expression: "monthSelectForm.endMonth"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.monthSelectDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmSyncMonthSelect }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  width: "420px",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }